module.exports = __webpack_public_path__ + "static/media/close-menu.b01002c7.svg";